// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3468":"8d02372f","8312":"ed71f4aa"}[chunkId] + ".chunk.css";
};